import { useEffect, useMemo } from 'react';

import { useFeatureFlagAsync } from '@order/LaunchDarkly';

import { useGetLoyaltyProfileQuery } from './GetLoyaltyProfile.query.generated';

export const useSweetpass = () => {
  // ––– Feature Flag –––

  const { value: isSweetpassEnabled, isStale: isSweetpassEnabledFlagLoading } =
    useFeatureFlagAsync('OPS-sweetpass-enabled', { listenForChanges: true });

  const isSweetpassFlagLoading = isSweetpassEnabledFlagLoading;

  // ––– Get Loyalty Profile Query –––

  const shouldPerformQuery =
    isSweetpassEnabled && !isSweetpassEnabledFlagLoading;

  const [getLoyaltyProfileResponse, getLoyaltyProfileQuery] =
    useGetLoyaltyProfileQuery({
      pause: true,
      requestPolicy: 'cache-and-network',
    });

  const loyaltyProfile = getLoyaltyProfileResponse.data?.loyaltyProfile ?? null;

  const isLoyaltyProfileQueryResolved =
    typeof getLoyaltyProfileResponse.data !== 'undefined';

  useEffect(() => {
    if (isLoyaltyProfileQueryResolved || !shouldPerformQuery) return;
    getLoyaltyProfileQuery();
  }, [
    isLoyaltyProfileQueryResolved,
    getLoyaltyProfileQuery,
    shouldPerformQuery,
  ]);

  return useMemo(
    () => ({
      isSweetpassEnabled,
      isSweetpassFlagLoading,
      isLoyaltyProfileLoading: !isLoyaltyProfileQueryResolved,
      loyaltyProfile,
    }),
    [
      isSweetpassEnabled,
      isSweetpassFlagLoading,
      isLoyaltyProfileQueryResolved,
      loyaltyProfile,
    ],
  );
};
